/** Partner row — AMD | PC Game Pass (HX-45, 2026-08-12; was Xbox Game Pass). */
export function Partners() {
  return (
    <div className="flex flex-col items-center gap-[5px] pt-5">
      <p className="font-body text-[clamp(0.85rem,1.05vw,1.25rem)] text-brand-muted">
        Meet our Partners
      </p>
      <img
        src="/assets/images/logos/amd-pc-game-pass.svg"
        alt="AMD and PC Game Pass"
        className="w-[clamp(12.1rem,14.1vw,16.9rem)]"
      />
    </div>
  );
}
